import styled from "styled-components";
import { Colors } from "../../../styles/colors";

export const Container = styled.div`
	background-color: #ffffff;
	border-radius: 24px;
	box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.12);
	position: relative;
	width: 100%;
	max-width: 560px;
	padding: 2.5rem 2.5rem 2rem;
	display: flex;
	flex-direction: column;
	align-items: center;

	.close {
		position: absolute;
		right: 1.5rem;
		top: 1.5rem;
		cursor: pointer;
		width: 1.5rem;
		height: 1.5rem;
	}

	.illustration {
		width: 100%;
		max-width: 400px;
		height: auto;
		margin-bottom: 1.5rem;
		object-fit: contain;
	}

	.title {
		font-family: "NotoSans-Regular";
		font-weight: 700;
		font-size: 1.25rem;
		line-height: 1.5rem;
		text-align: center;
		color: ${Colors.primary_blue_k_main};
		margin: 0 0 0.75rem;
		max-width: 420px;
	}

	.subtitle {
		font-family: "NotoSans-Regular";
		font-weight: 400;
		font-size: 0.875rem;
		line-height: 1.25rem;
		text-align: center;
		color: ${Colors.neutral_grey_k_60};
		margin: 0 0 1.5rem;
	}

	.features {
		list-style: none;
		padding: 0;
		margin: 0 0 2rem;
		width: 100%;
		max-width: 380px;
		display: flex;
		flex-direction: column;
		gap: 0.75rem;
	}

	.featureItem {
		display: flex;
		align-items: center;
		gap: 0.75rem;
		font-family: "NotoSans-Regular";
		font-weight: 400;
		font-size: 0.9375rem;
		line-height: 1.25rem;
		color: ${Colors.primary_blue_k_main};

		svg {
			flex-shrink: 0;
		}
	}

	.ctaButton {
		width: 100%;
		padding: 0.875rem 1.5rem;
		border: none;
		border-radius: 12px;
		background-color: ${Colors.primary_blue_k_main};
		color: #fafafa;
		font-family: "Kanit-Regular";
		font-weight: 600;
		font-size: 1rem;
		line-height: 1.5rem;
		text-align: center;
		cursor: pointer;
		transition: background-color 0.3s ease;

		&:hover {
			background-color: ${Colors.primary_blue_k_dark_2};
		}
	}
`;
